import { useSelector } from 'react-redux'

const useDisplayNames = () => {
    // @ts-expect-error redux store is not typed properly
    const displayNames = useSelector((state) => state?.settings?.displayNames || {})

    const getDisplayName = (name: string, fallback: string) => {
        return displayNames[name] || fallback
    }

    return { getDisplayName }
}

export default useDisplayNames
